// src/components/ui/CopyableCode.tsx
"use client";
import { useState } from "react";

type Props = {
  code: string;
  className?: string;
  ariaLabel?: string;
};

export function CopyableCode({ code, className = "", ariaLabel = "Copy code" }: Props) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    } catch {
      // silent fail
    }
  }

  return (
    <div className={`relative rounded-lg border border-border bg-[hsl(var(--muted))] ${className}`}>
      <pre className="text-xs overflow-x-auto whitespace-pre p-3 pr-24 m-0 text-left leading-5">
        {code}
      </pre>
      <button
        type="button"
        onClick={handleCopy}
        aria-label={copied ? "Copied" : ariaLabel}
        className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium rounded-md border border-border bg-[hsl(var(--bg))] text-foreground shadow-sm hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))] transition-opacity"
      >
        {copied ? "Copied!" : "Copy"}
      </button>
    </div>
  );
}
